import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { authAPI } from '../services/api'

interface LoginProps {
  setToken: (token: string) => void
}

export default function Login({ setToken }: LoginProps) {
  const [email, setEmail]       = useState('')
  const [password, setPassword] = useState('')
  const [error, setError]       = useState('')
  const [loading, setLoading]   = useState(false)
  const navigate = useNavigate()

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault()
    if (loading) return
    setLoading(true)
    setError('')
    try {
      const res = await authAPI.login(email, password)
      localStorage.setItem('atm_token', res.data.access_token)
      localStorage.setItem('atm_plan', res.data.plan)
      setToken(res.data.access_token)  // ← triggers App re-render
      navigate('/dashboard')
    } catch (err: any) {
      setError(err.response?.data?.detail || 'Login failed')
    } finally {
      setLoading(false)
    }
  }

  // ... rest of component unchanged
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.logo}>AITradeMinds</h1>
        <p style={styles.subtitle}>Options Flow Intelligence</p>
        <form onSubmit={handleLogin}>
          <input
            style={styles.input}
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
          <input
            style={styles.input}
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
          {error && <p style={styles.error}>{error}</p>}
          <button style={styles.button} type="submit" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
        <p style={styles.link}>
          No account? <Link to="/register">Register free</Link>
        </p>
      </div>
    </div>
  )
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    minHeight: '100vh',
    background: '#0a0e1a',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  card: {
    background: '#111827',
    border: '1px solid #1f2937',
    borderRadius: 12,
    padding: 40,
    width: 380,
    textAlign: 'center',
  },
  logo: { color: '#00d4ff', fontSize: 28, margin: 0 },
  subtitle: { color: '#6b7280', fontSize: 14, marginBottom: 32 },
  input: {
    width: '100%',
    padding: '12px 16px',
    marginBottom: 16,
    background: '#1f2937',
    border: '1px solid #374151',
    borderRadius: 8,
    color: '#fff',
    fontSize: 15,
    boxSizing: 'border-box',
  },
  button: {
    width: '100%',
    padding: '13px',
    background: '#00d4ff',
    color: '#000',
    border: 'none',
    borderRadius: 8,
    fontSize: 16,
    fontWeight: 700,
    cursor: 'pointer',
    marginTop: 8,
  },
  error: { color: '#ef4444', fontSize: 13, marginBottom: 8 },
  link: { color: '#6b7280', fontSize: 13, marginTop: 20 },
}